var exports = {
  "i": "xaee3c4fa--3b953b--wrapper",
};

module.exports = exports;
